"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINGERPRINT = exports.ChecklistView = exports.AvroOptional = void 0;
exports.log = log;
const signals_logger_1 = require("@indeed/signals-logger");
const ChecklistView_1 = require("./ChecklistView");
Object.defineProperty(exports, "ChecklistView", { enumerable: true, get: function () { return ChecklistView_1.ChecklistView; } });
var signals_logger_2 = require("@indeed/signals-logger");
Object.defineProperty(exports, "AvroOptional", { enumerable: true, get: function () { return signals_logger_2.AvroOptional; } });
exports.FINGERPRINT = "4f157e77e6c732ba";
function log(message) {
    (0, signals_logger_1.log)(exports.FINGERPRINT, message);
}
